type FormHeadersProps = {
  errors?: any;
  warnings?: { [key: string]: string };
};

const FormErrors = ({ errors, warnings = {} }: FormHeadersProps) => {
  const errorList = Object.values(errors).flat();
  const warningList = Object.values(warnings).flat();
  const hasErrors = errorList.length > 0;
  const hasWarnings = warningList.length > 0;
  const hasErrorsOrWarnings = hasErrors || hasWarnings;
  const hasErrorsAndWarnings = hasErrors && hasWarnings;

  return (
    <div className="form__errorsContainer" data-testid="form-errors-container">
      {hasErrorsOrWarnings && (
        <>
          {hasErrorsAndWarnings && (
            <h3 className="form__errorsHeader">Errors</h3>
          )}
          {hasErrors && (
            <ul className="form__errorList">
              {errorList.map((error, i) => (
                <li key={`error-list-item-${i}`}>{error}</li>
              ))}
            </ul>
          )}
          {hasErrorsAndWarnings && (
            <h3 className="form__warningsHeader">Warnings</h3>
          )}
          {hasWarnings && (
            <ul className="form__warningList">
              {warningList.map((warning, i) => (
                <li key={`warning-list-item-${i}`}>{warning}</li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default FormErrors;
